
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AtTa from 'vue-at/dist/vue-at-textarea'
import { IRecipient } from '@/entities/notices'
import { pendoTrackEvent } from '@/utils/pendo'

@Component<MentionableEditor>({
    components: {
        AtTa,
    },
})
export default class MentionableEditor extends Vue {
    @Prop({ type: Array, default: [] }) public members!: IRecipient[]
    @Prop({ type: String, default: '' }) public placeholder!: string
    @Prop({ type: String, default: '' }) public text!: string
    @Prop({ type: Boolean, default: false }) public compacted!: boolean
    @Prop({ type: Boolean, default: false }) public inModal!: boolean
    @Prop({ type: Boolean, default: false }) public atMentionsBelow?: boolean

    //TODO: Clean this up entire file up, seems to be taken from WebView/TextInput.
    public memberSort(name, chunk) {
        return name.toLowerCase().indexOf(chunk.toLowerCase()) === 0
    }

    public onInputKeydown(evt) {
        if (evt.key === '@') {
            pendoTrackEvent('mention_started')
        }
    }

    public onInsertMention(recipient: IRecipient) {
        const mentions = this.members.filter((mention) =>
            this.text.includes(`@${mention.name} `)
        )
        // when user select a recipient, the function is called, but the name of new
        // receipient has not been added in to text, therefore we should push the new
        // receipient manually
        mentions.push(recipient)

        pendoTrackEvent('mention_added')
        this.$emit('mention', mentions)
    }

    public onMessageUpdate(e: Event) {
        this.$emit('input', (e.currentTarget as any).value)
        // when DELETE any charactor, we need to walk through the mentions array to
        // confirm whether any mentions have been removed
        const mentions = this.members.filter((mention) =>
            this.text.includes(`@${mention.name} `)
        )
        this.$emit('mention', mentions)
    }
}
